import { render } from "./Whitelist.vue?vue&type=template&id=3a4a79c0&scoped=true"
import script from "./Whitelist.vue?vue&type=script&lang=js"
export * from "./Whitelist.vue?vue&type=script&lang=js"

import "./Whitelist.vue?vue&type=style&index=0&id=3a4a79c0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\c.turnbull.VT\\Documents\\GitHub\\vars-portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a4a79c0"]])

export default __exports__